import React from 'react';
import SignIn from "../components/SignIn";
import ScrollToTop from '../components/ScrollToTop';

const SigninPage = () => {
  return(
    <>
      <ScrollToTop />
      <SignIn />
    </>
  );
};

export default SigninPage;
